import { render, staticRenderFns } from "./FeeScheduleTierList.vue?vue&type=template&id=065831da&"
import script from "./FeeScheduleTierList.vue?vue&type=script&lang=js&"
export * from "./FeeScheduleTierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports